import { IconSvg, IconSvgProps } from "./icon"

export default function InfoCircleFill(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 24A12 12 0 1 0 12 0a12 12 0 0 0 0 24ZM9.429 16.071a1.071 1.071 0 1 0 0 2.143h5.143a1.071 1.071 0 1 0 0-2.143h-1.5V11.143A1.071 1.071 0 0 0 12 10.071H10.286a1.071 1.071 0 1 0 0 2.143h.643v3.857H9.429ZM13.714 6.857a1.714 1.714 0 1 1-3.429 0a1.714 1.714 0 0 1 3.429 0Z"
        clipRule="evenodd"
      />
    </IconSvg>
  )
}
